export const SAVED_LAYOUT_VALUE_KEY = 'layoutValue';
export const DIALOGS_DESCRIPTION_POPUP_KEY = 'isDialogDescriptionClosed';
export const CHAT_DESCRIPTION_POPUP_KEY = 'isChatDescriptionClosed';